// A variant classification as one source wrote it, for display (TGCLOUD-1893).
//
// One of the ACMG tiers ("Pathogenic", "Likely benign", "VUS"), or one of
// ClinVar's own aggregate classifications, is fixed vocabulary and is shown in
// the user's language. Anything else is the source's own words (a laboratory's
// wording kept verbatim, an imported value) and is shown exactly as recorded:
// that is record data, and never goes to t().
//
// Translating the vocabulary does not reconcile or re-tier anything: the words
// shown are the source's own, in another language (variantPathogenicity.js).

import { strictAcmgTier } from 'src/util/variantPathogenicity';
import { english } from 'src/i18n/language';

// ClinVar's compound classifications, which strictAcmgTier leaves out on
// purpose (they are not one tier). Compared in lower case, spaces collapsed.
const CLINVAR_AGGREGATES = new Set([
  'pathogenic/likely pathogenic',
  'benign/likely benign',
  'conflicting classifications of pathogenicity',
  'conflicting interpretations of pathogenicity'
]);

const keyOf = (raw) => raw.trim().toLowerCase().replace(/\s+/g, ' ');

/** True when `raw` is classification vocabulary rather than a source's prose. */
export const isClassificationVocabulary = (raw) =>
  typeof raw === 'string' &&
  (Boolean(strictAcmgTier(raw)) || CLINVAR_AGGREGATES.has(keyOf(raw)));

/**
 * `raw` for display: translated when it is classification vocabulary, as
 * recorded otherwise (null, undefined and '' come back unchanged).
 *
 * @param {unknown} raw
 * @param {Function} [t] useAutoTranslation's t; English when omitted
 */
export const classificationText = (raw, t = english) =>
  isClassificationVocabulary(raw) ? t(raw.trim()) : raw;
